import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Config from '../../core/config';

const Captcha = ({ captchaValue, handleCloseCaptcha = () => { } }) => {
    return (
        <div className='my-3 d-flex justify-content-center align-items-center'> <ReCAPTCHA sitekey={Config.CAPTCHA_SITE_KEY} ref={captchaValue} theme="dark" size="normal" onChange={(e) => { handleCloseCaptcha() }} /> </div>
    );
};

export default Captcha;
